module.exports = __webpack_public_path__ + "static/media/man-gym.2d45dabd.png";